import Api from 'App/api'

export const getMessages = Api.get({
  controller: 'messages',
  action: 'list',
})

export const postDeleteMessages = Api.post({
  controller: 'messages',
  action: 'delete',
})

export const markRead = Api.post({
  controller: 'messages',
  action: 'markRead',
})

export const markUnread = Api.post({
  controller: 'messages',
  action: 'markUnread',
})

export const postMessage = Api.post({
  controller: 'property_contact',
  action: 'contact',
})

export const postMessageWithAttachments = Api.postMultipart({
  controller: 'property_contact',
  action: 'contact',
})

export const getMessagesCount = Api.get({
  controller: 'messages',
  action: 'countUnread',
})

export const getMessagesContent = Api.get({
  controller: 'messages',
  action: 'getContent',
})
